import { Component, OnInit, inject } from "@angular/core";
import { MailingAddressService } from "../../../services";
import { IdValuePair, MailingAddressViewModel } from "@tylertech/tyler-api-types";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormGroup } from "@angular/forms";
import { DataRowState, Utilities } from "@tylertech/shared-module";

export interface MailingAddressDialogData
{
    readonly inUseMailingAddresses: ReadonlyArray<IdValuePair>;
    readonly mailingAddresses: ReadonlyArray<MailingAddressViewModel>;
    readonly parentId: string;
    readonly parentType: string;
    readonly viewOnly: boolean;
}

@Component({
    selector: "mailing-address-dialog-component",
    templateUrl: "./mailingAddressDialog.tmpl.html",
    standalone: false
})
export class MailingAddressDialogComponent implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<MailingAddressDialogComponent, Array<MailingAddressViewModel> | undefined>>(MatDialogRef);
    private readonly data = inject<MailingAddressDialogData>(MAT_DIALOG_DATA);
    private $mailingAddressService = inject(MailingAddressService);

    mailingAddresses: Array<MailingAddressViewModel>;
    readonly dialogForm: FormGroup;

    constructor()
    {
        this.dialogForm = new FormGroup({});

        // TODO - should this be a deep copy instead of this shallow copy?
        this.mailingAddresses = Utilities.deepCopy(this.data.mailingAddresses as Array<MailingAddressViewModel>);
    }

    get parentType(): string { return this.data.parentType; }
    get parentId(): string { return this.data.parentId; }
    get usages(): ReadonlyArray<IdValuePair> { return this.data.inUseMailingAddresses; }
    get viewOnly(): boolean { return this.data.viewOnly; }


    get invalid(): boolean { return this.dialogForm.invalid; }

    ngOnInit(): void
    {
        if (!this.mailingAddresses.length)
        {
            this.createNewMailingAddress(true);
        }
    }

    addClicked(): void
    {
        this.createNewMailingAddress();
    }

    private createNewMailingAddress(primary?: boolean): void
    {
        const newItem: MailingAddressViewModel = {
            Id: Utilities.generateRandomGuid(),
            ContactId: this.parentId,
            RowState: DataRowState.Added,
            IsPrimary: primary,
            Attention: undefined,
            Line1: undefined,
            Line2: undefined,
            City: undefined,
            State: undefined,
            PostalCode: undefined,
            Country: undefined,
            CertificationResults: undefined,
            FullMailingAddress: undefined,
            IsCertified: undefined,
            IsForwarding: undefined,
        };
        this.mailingAddresses.push(newItem);
    }

    doneClicked(): void
    {
        if (this.dialogForm.invalid)
        {
            return;
        }

        this.$mailingAddressService.confirmAndSaveChanges(this.mailingAddresses)
            .then(mailingAddresses =>
            {
                this.dialogRef.close(mailingAddresses);
            });
    }

    cancelClicked(): void
    {
        this.mailingAddresses = Utilities.deepCopy(this.data.mailingAddresses as Array<MailingAddressViewModel>);
        this.dialogRef.close(this.mailingAddresses);
    }
}
